import { Reveal } from "@/components/Motion";

const chapters = [
  {
    n: "01",
    title: "We keep families together.",
    body: "Our mission is to help keep families together by promoting housing stability, increasing independence, and connecting families to long-term community resources and support systems.",
  },
  {
    n: "02",
    title: "We support mothers with special needs.",
    body: "We serve women with intellectual and mental health disabilities, and mothers raising children who often have developmental or special needs of their own — meeting each family where they are.",
  },
  {
    n: "03",
    title: "We partner for stronger care.",
    body: "Independence Way partners with the Division of Child Protection and Permanency (DCP&P) to strengthen and stabilize vulnerable families through coordinated support services and community-based care.",
  },
];

const Manifesto = () => (
  <section
    id="mission"
    data-testid="mission-section"
    className="relative py-28 md:py-40 px-6 md:px-10 max-w-[1400px] mx-auto"
  >
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-[#C85A3C] mb-6">
              Our Mission
            </p>
            <h2 className="font-serif-display font-light leading-[1.02] tracking-tight text-4xl md:text-5xl text-[#1A1A1A]">
              A promise of stability during the hardest transitions.
            </h2>
          </Reveal>
        </div>
      </div>

      <div className="lg:col-span-7 lg:col-start-6 flex flex-col">
        {chapters.map((c, i) => (
          <Reveal
            key={c.n}
            delay={i * 0.05}
            className={`py-10 md:py-14 border-t border-[#1A1A1A]/10 ${
              i === chapters.length - 1 ? "border-b" : ""
            }`}
            data-testid={`manifesto-chapter-${c.n}`}
          >
            <div className="flex items-start gap-6 md:gap-10">
              <span className="font-serif-display text-2xl md:text-3xl text-[#C85A3C] mt-1 shrink-0">
                {c.n}
              </span>
              <div>
                <h3 className="font-serif-display text-3xl md:text-4xl font-light tracking-tight text-[#1A1A1A] leading-tight">
                  {c.title}
                </h3>
                <p className="mt-4 text-base md:text-lg leading-relaxed text-[#1A1A1A]/70 max-w-xl">
                  {c.body}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
